const STATE = {
  organizations: [],
  extensions: null,
  collectionsForUrl: {},
  paymentInformationForUrl: {},
  coords: null,
}

export default STATE
